export const flatten = (
  obj: Record<string, string | object>,
  convertToFlattenJson: boolean,
) => {
  if (!convertToFlattenJson) {
    return obj;
  }
  const result: Record<string, string> = {};
  for (const i in obj) {
    const key = i;
    if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
      const recursiveObj = obj[key] as Record<string, string | object>;
      const temp = flatten(recursiveObj, convertToFlattenJson);
      for (const j in temp) {
        const path = [i, ".", j].join("");
        const value = (temp as Record<string, string>)[j];
        result[path] = value;
      }
    } else {
      result[i] = (obj as Record<string, string>)[key];
    }
  }
  return result;
};
